<template>
  <v-app class="app">
    <div class="bg" />
    <div class="logo" />
    <v-main class="d-flex align-center justify-center">
      <slot />
    </v-main>
  </v-app>
</template>

<style lang="scss" scoped>
.app {
  position: relative;
  height: 100vh;
}

.bg {
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("/uko-tower/landscape-background.webp");
  background-size: cover;
  width: 100vw;
  height: 100vh;
}

.logo {
  position: fixed;
  top: 30px;
  right: 30px;
  background-image: url("/uko-tower/logo.png");
  background-size: contain;
  height: 100vh;
  width: 100px;
}
</style>
